import { OnboardingSurveyStore } from '@stores/OnboardingSurveyStore';
import apiResponse from '@stores/ApiResponse';
import { QuestionView, ResponseView, SectionView } from '@views';
import dashboardView from '@views/DashboardView';
import { Question } from '@models/Question';
import { Response } from '@models/Response';
import { Section } from '@models/Survey';
import { useQuery } from '@tanstack/react-query';
import { Duration } from 'luxon';

export class OnboardingSurveyViewCreator {
  constructor(private readonly store: OnboardingSurveyStore = new OnboardingSurveyStore()) {}

  async createView(cohortId: number) {
    const sections = await apiResponse.handleApiResponse<Section[]>(() => this.store.readByCohortId(cohortId));
    const initialSection = sections[0] ?? dashboardView.Empty.section;
    return {
      ...initialSection,
      description: '',
      title: initialSection.name,
      questions: initialSection.questions.map(
        (question: Question) =>
          ({
            ...question,
            userResponse: '',
            responses: question.responses.map(
              (response: Response) =>
                ({
                  ...response,
                  selected: false,
                  textResponse: '',
                }) as ResponseView
            ),
          }) as QuestionView
      ),
    } as SectionView;
  }
}

export const useOnboardingSurveyViewCreator = (groupId: number) =>
  useQuery({
    queryKey: ['onboardingSurveyViewCreator', groupId],
    queryFn: () => new OnboardingSurveyViewCreator().createView(groupId),
    staleTime: Duration.fromObject({ minutes: 1 }).milliseconds,
  });
